var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "url(#paint0_linear_25124_101342)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1684 24.7246C74.1836 24.7246 83.1128 33.5082 83.1128 44.3414C83.1128 55.1774 74.1836 63.961 63.1684 63.961C52.1532 63.961 43.224 55.1774 43.224 44.3414C43.224 33.5054 52.156 24.7246 63.1684 24.7246ZM63.1684 24.7246C74.1836 24.7246 83.1128 33.5082 83.1128 44.3414C83.1128 55.1774 74.1836 63.961 63.1684 63.961C52.1532 63.961 43.224 55.1774 43.224 44.3414C43.224 33.5054 52.156 24.7246 63.1684 24.7246ZM55.6896 70.5018H72.3132C86.5428 70.5018 98.076 81.8446 98.076 95.8418V97.4742C98.076 102.99 86.54 103.2 72.3132 103.2H55.6896C41.46 103.2 29.9268 103.192 29.9268 97.4742V95.8418C29.9268 81.8446 41.46 70.5018 55.6896 70.5018Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25124_101342",
    x1: 86.1837,
    y1: 128,
    x2: 41.8163,
    y2: 0.00000254963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF99B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D030DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar_default.ce5c58f6adbb91c6c5c299b93e64d255.svg";
export { ForwardRef as ReactComponent };